export function asRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }
  return value as Record<string, unknown>;
}

export function asString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function asStringArray(value: unknown): string[] | undefined {
  if (
    !Array.isArray(value) ||
    !value.every((entry) => typeof entry === 'string')
  ) {
    return undefined;
  }
  return value;
}

export function optionalString(
  record: Record<string, unknown>,
  key: string,
): Record<string, string> {
  const value = record[key];
  return typeof value === 'string' ? {[key]: value} : {};
}

export function firstStringValue(
  record: Record<string, unknown>,
  ...keys: string[]
): string {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === 'string') {
      return value;
    }
  }

  return '';
}
